export default "__VITE_ASSET__c749edf3__"